import React, { useState, createRef, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import logo from '../../images/Logo.png';
import iconSearch from '../../images/icon-search.png';
import iconMenu from '../../images/icon-menu.png';
import introCertification from '../../images/introCertification.png';
import introReceipt from '../../images/introReceipt.png';
import introImgFragment from '../../images/introImgFragment.png';
import './style.css';
import introBgText from '../../images/introBgText.png';
import introductionLogo from '../../images/introductionlogo.png';
import { useRecoilState } from 'recoil'
import { ItemNameState, ItemPriceState, OptionsState, PostObjectState } from './atoms';
import Select from "react-select"; //라이브러리 import
import { useRef } from 'react';
import ShowSlide from '../../Common/Component/SlideShowGalleryDetail';


function AddItem() {

  const items = [
    { value: "online", label: "온라인" },
    { value: "offlone", label: "오프라인" }
  ]
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: '100%', // 수정할 부분
    }),
  };

  //원래는 select 태그 안에 들어가는 애들을 배열로 만들어준다.
  const inputFiles = useRef();
  const thumbnailImgRef = useRef();
  const PhotoSubmit = useRef(); // dom 에서 ref 기능으로 변경

  const [itemName, setItemName] = useRecoilState(ItemNameState);
  const [itemPrice, setItemPrice] = useRecoilState(ItemPriceState);
  const [radioValue, setRadioValue] = useState("1");
  const [TypeAdd, setTypeAdd] = useState('');
  const [itemColor, setItemColor] = useState([{ value: "default", label: "선택" }]);
  const [selectedOption, setSelectedOption] = useState({ value: "default", label: "선택" });
  const [option, setOption] = useRecoilState(OptionsState);
  const [uploadFiles, setUploadFiles] = useState();
  // const [count,setCount] = useState(0);
  // const [value, setValue] = useState(2);



  // 게시글 목록 초기화
  const clearData = () => {
    try{

    
    PhotoSubmit.current.disabled = false;

    // 모든 파일 입력 제거
    if (inputFiles.current) {
        inputFiles.current.value = null;
    }
    while (thumbnailImgRef.current.firstChild) {
      thumbnailImgRef.current.removeChild(thumbnailImgRef.current.firstChild);
  }
    // 여러 썸네일 이미지를 처리하기 위한 로직
    // 예를 들어, 여러 썸네일 이미지가 thumbnailImgRef 배열에 저장되어 있다고 가정
     
  }
  catch(ex){
    alert('클리어 실패');
  }
    // 단일 썸네일 이미지를 처리하는 기존 로직
   
}


  // 사진 업로드
const uploadImages = () => {
  //사진업로드 validation
  if (inputFiles.current.files.length === 0) {
    alert('사진을 선택해주세요.');
    return;
  }

  if (!itemName) {
    alert('상품명을 입력해주세요.');
    return;
  }

  if (!itemPrice) {
    alert('상품 가격을 입력해주세요.');
    return;
  }

  if (!selectedOption) {
    alert('상품 옵션을 선택해주세요.');
    return;
  }



  PhotoSubmit.current.disabled = 'disabled';
  const form = document.getElementById("myForm");
  const formData = new FormData(form);
  
  // Array.from(inputFiles.current.files).forEach((file) => {
  //     formData.append('imgs', file);
  // });

    
  
  
  formData.append('Radio', radioValue);
  
  fetch('/upload/ProductRegistration', {
      method: 'POST',
      mode:'cors',
      credentials:'include',
      body: formData
  }).then((res) => {
      console.log('응답:'+ res);  
      clearData();
      alert('상품등록이 완료 되었습니다.');
      
  }).catch(err => {
      alert(err);
      clearData();
  });
};

const uploadImgsPreview = () => {
  let fileInfos = Array.from(inputFiles.current.files);
  setUploadFiles(fileInfos);

  // 이미지 여러 개를 처리하기 위한 로직
  fileInfos.forEach(fileInfo => {
      let reader = new FileReader();
      reader.onload = function (event) {
          let image = new Image();
          image.onload = function () {
              // 이 부분은 원래 코드에서의 이미지 크기 및 비율 조절 로직이라 
              // 여러 이미지에 맞게 적절히 수정이 필요할 수 있습니다.
              let ratio = image.width / image.height;
              let thumbnail = document.createElement("img");

              if (ratio > 1) {
                  thumbnail.width = 400;
                  thumbnail.height = 400 / ratio;
              } else {
                  thumbnail.height = 400;
                  thumbnail.width = 400 * ratio;
              }

              thumbnail.src = event.target.result;
              document.getElementById("thumbnailSrc").appendChild(thumbnail);
          }

          image.src = event.target.result;
      }

      if (fileInfo) {
          reader.readAsDataURL(fileInfo);
      }
  });
};



  // 카운트 증가
  const initialItems = [
    { id: 'y1', value: 2, count: 0 },
    { id: 'y2', value: 2, count: 0 },
    { id: 'y3', value: 2, count: 0 },
    { id: 'y4', value: 2, count: 0 }
  ];
  const [itemsCount, setItemsCount] = useState(initialItems);
  const plusItem = (id) => {
    setItemsCount(
      itemsCount.map(item =>
        item.id === id && item.value > 0
          ? { ...item, value: item.value - 1, count: item.count + 1 }
          : item
      )
    );
  };
  const minusItem = (id) => {
    setItemsCount(
      itemsCount.map(item =>
        item.id === id && item.value <= 1
          ? { ...item, value: item.value + 1, count: item.count - 1 }
          : item
      )
    );
  };

  return (
    <>

<hr width='100%' color='#fff' />
      <div className='addPage'>
        <h1 style={{ margin: '20px' }} className='AddItemTitle'>상품등록</h1>
        <form id='myForm' method="POST" encType="multipart/form-data" style={{ display: '', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', margin: '20px' }} className='AddContainer'>
          <aside>
              <div style={{ width: '500px', height: 700, border: 'none ', justifyContent: 'center', display: 'flex', marginBottom: ' 25px' }} className='ThumbnailView'>
                  <ShowSlide />
                  <div ref={thumbnailImgRef} id="thumbnailSrc"></div>
              </div>
              <input ref={inputFiles} style={{ borderWidth: '0px', display: '' }} id='img' type="file" name="imgs" multiple onChange={() => uploadImgsPreview()} />
          </aside>
            {/* 재고확인 */}
            <table className='AddTable'>
              <thead>
                <tr>
                  <th style={{backgroundColor:'#87CEFA', fontSize:'1.5rem'}}>사이즈</th>
                  <th style={{backgroundColor:'#87CEFA',fontSize:'1.5rem'}}>재고</th>
                  <th style={{backgroundColor:'#87CEFA', fontSize:'1.5rem'}}>수량</th>
                </tr>
              </thead>
              <tbody>
                {itemsCount.map(item => (
                  <tr key={item.id}>
                    <td><span>{item.id}</span></td>
                    <td>{item.value}</td>
                    <td>
                      <button onClick={() => minusItem(item.id)}>-</button>
                      <span>{item.count}</span>
                      <button onClick={() => plusItem(item.id)}>+</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
      
        </div>
        
        <hr width='100%' />

        {/* 입력란 */}
        <div className='addInputInfo'>
          <section className='AddItemSection'>
            <ul>
              <li>
                <div className='AddItemInput'>
                  <label style={{width:'20%'}}>상품명</label>
                  <input style={{width:'70%'}} type='text' id='model' name="model" onChange={(e) => { setItemName(e.target.value) }} />
                </div>
              </li>
              <li>
                <div className='AddItemInput'>
                  <label style={{width:'25%'}}>상품 타이틀</label>
                  <input style={{width:'70%'}} type='text' id='title' name="title" onChange={(e) => { setItemName(e.target.value) }} />
                </div>
              </li>
              <li>
                <div className='AddItemInput' >
                  <label style={{width:'20%'}}>상품 가격</label>
                  <input style={{width:'70%'}} type='text' id='price' name="price" onChange={(e) => { setItemPrice(e.target.value) }} />
                </div>
                </li>
              <li>
                <div className='AddItemInput' >
                  <label style={{width:'35.5%'}}>옵션 추가</label>
                  <input id='optionValue' name="optionValue" onChange={(e) => { setTypeAdd(e.target.value) }} placeholder='추가할 옵션을 입력해주세요'/>
                  <button style={{margin:'0, 0, 0, 20px'}} type='button' className='addBtn' onClick={() => setOption(prevOptions => [...prevOptions, { value: TypeAdd, label: TypeAdd }])}>+</button>
                </div>
              </li>
              <li>
                <div style={{  width: '100%', alignItems: 'center' }}>
                  <label style={{marginBottom:'10px', display:'block'}}>상품옵션</label> 
                  <Select styles={customStyles} defaultValue={selectedOption} value={selectedOption} options={ option} onChange={(e) => setSelectedOption(e)} />
                </div>
              </li>
              <li>
                <div>
                  <label style={{marginBottom:'10px',marginTop:'20px', display:'block'}}>운송방법</label> 
                  <div>
                    <label><input type="radio" value="1" checked={radioValue === "1"} onChange={(e) => setRadioValue(e.target.value)} />배송비 포함</label>
                    <label style={{ marginLeft: '20px' }}><input type="radio" value="2" checked={radioValue === "2"} onChange={(e) => setRadioValue(e.target.value)} />착불</label>
                  </div>
                </div>
              </li>
            </ul>
            <button style={{marginTop:'20px'}} type='button' ref={PhotoSubmit} className='SubmitButton' 
            onClick={() => {
              if (window.confirm('상품을 등록하시겠습니까?')) {
                  uploadImages();
              }
              }}>상품등록
          </button>
          </section>
        </div>
        <hr width='100%' />
      </form>
        <div className="addItemPreview">
          <ul>
            <li>데이터 콘솔</li>
            <li>상품명:{itemName}</li>
            <li>상품가격:{itemPrice}</li>
            <li>상품옵션:{option.label}</li>
            <li>운송방법:{radioValue === "1" ? <label>배송비포함</label> : <label>착불</label>}</li>
            <li>{JSON.stringify(uploadFiles)}</li>
            <li>{ }</li>
          </ul>
        </div>
      </div>
     
      
    </>
  );
}

export default AddItem;